import { PlaceVM, FiltersFormPlace } from 'civil-status/view-models/place';
import { HeadCell } from 'shell/components/shared/table/types';
import * as yup from 'yup';
import { CommonCivilStatusCrumbs } from '../breadcrumb';
import { CivilStatusAuthorizations } from 'shell/authorizations/civil-status';

export const authsObj = Object.freeze({
  read: [CivilStatusAuthorizations.AnscVisualizzaLuogoNascita],
  create: [CivilStatusAuthorizations.AnscAggiungiLuogoNascita],
  edit: [CivilStatusAuthorizations.AnscModificaLuogoNascita],
  delete: [CivilStatusAuthorizations.AnscEliminaLuogoNascita],
});

export const headCells: HeadCell<PlaceVM, keyof PlaceVM>[] = [
  {
    id: 'id',
    label: 'Id',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'startValidityDate',
    label: 'Data inizio validità',
  },
  {
    id: 'endValidityDate',
    label: 'Data fine validità',
  },
  {
    id: 'orderNumber',
    label: 'N. ordinamento',
  },
  {
    id: 'action',
    label: '',
  },
];

export const headCellsMinisterReligion: HeadCell<PlaceVM, keyof PlaceVM>[] = [
  {
    id: 'id',
    label: 'Id',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'startValidityDate',
    label: 'Data inizio validità',
  },
  {
    id: 'endValidityDate',
    label: 'Data fine validità',
  },
  {
    id: 'orderNumber',
    label: 'N. ordinamento',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchema = yup.object({
  id: yup.string(),
  description: yup.string(),
});

export const CommonBirthplaceCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Ricerca luogo nascita',
    path: '/stato-civile/luogo-nascita',
  },
];

export const CommonDeathplaceCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Ricerca luogo decesso',
    path: '/stato-civile/luogo-decesso',
  },
];

export const CommonDeathAutorityCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Ricerca autorità decesso',
    path: '/stato-civile/autorita-decesso',
  },
];

export const CommonReligiousCultsCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Ricerca culti religiosi',
    path: '/stato-civile/culti-religiosi',
  },
];

export const CommonMinisterReligionCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Ricerca ministro di culto',
    path: '/stato-civile/ministro-culto',
  },
];

export const initialValues: FiltersFormPlace = {
  id: '',
  description: '',
  page: 0,
  rowsPerPage: 10,
  orders: {},
};
